export const persons: TableModule = {
    name: "persons",
    route: "spa.organisations.persons",
    defaultOrder: {
        column: "lastname|firstname",
        direction: "asc"
    },
    routeParams: [{
        param: "organisation",
        prop: "organisation_id"
    }],
    columns: [
        {
            name: "name",
            sortable: true,
            sortBy: "firstname|lastname",
            mobile: true,
            width: "w-1/2 sm:w-auto"
        }, {
            name: "birthday",
            breakpoint: "md"
        }, {
            name: "contact",
            width: "sm:w-auto"
        }, {
            name: "personLinks",
            breakpoint: "md",
            mobile: true,
            width: "w-1/3 sm:w-auto"
        }
    ],
    filters: [],
    quickFilters: [],
    tools: [
        {
            isCreateAction: true,
            ability: ["create", "persons"]
        }, {
            name: 'persons.showPlayingAuthorization',
        }
    ]
}